import { seedgreenAPI } from "seedgreen-shared/api/axios";
import { sendToast } from "@/utils/sendToast";
import { i18n } from "@/utils/i18n";

export function setupAxiosInterceptors() {
	seedgreenAPI.interceptors.response.use(
		(response) => response,
		(error) => {
			if (
				error.response?.status === 403 &&
				error.config?.method !== "get"
			) {
				sendToast(
					i18n.global.t("error.permission-denied"),
					3000,
					"warning",
				);
			}
			return Promise.reject(error);
		},
	);
}
